export default __webpack_public_path__ + "static/voronoi-bcdaa35fcefb4020c1746b1142e22d24.png";